module.exports = __webpack_public_path__ + "img/execution_background.d7009ce2.png";